<template>
    <div v-if="hasAuth('Admin')">
      <list-container  :header="translate('externalSignerImport.externalSigners')"  v-show="!$route.params.id" :showSearch="true" @search="searchExternalSigners">
        <template v-slot:commands>
          <button type="button" style="margin-left: 10px;" class="btn btn-success " @click="$router.push({ name: 'ExternalSignerImport' })">
            {{translate('externalSignerImport.importFromExcel2')}}
          </button>
          <excel-exporter table-id="externalSignerExport" :columns="columns" url="/externalsigner/getforexport" modelName="ExternalSigner" orderBy="Name"></excel-exporter>
          <button type="button" style="margin-left: 10px;" class="btn btn-primary " @click="$router.push({name: 'ExternalSignerDetail',params: { id: '000000000000000000000000' },})">
            {{translate('externalSignerImport.newExternalSigner')}}
          </button>
        </template>
          <list
            ref="externalSigners"
            :columns="columns"
            url="/externalsigner/get"
            modelName="ExternalSigner"
            :predicate="predicate"
            :filter="filter"
            orderBy="Name"
          >
          </list>
          <external-signer-import v-if="showModal" @onsave="setImportResult" @close="closeImportModal"> </external-signer-import>
      </list-container>
      <router-view v-if="$route.params.id"/>
    </div>
    <div v-else class="alert alert-danger">
      {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
  </template>
  
  <script>
  import list from "../components/List.vue";
  import listContainer from "../components/ListContainer.vue";
  import ExternalSignerImport from "../components/ExternalSignerImport.vue";
  import ExcelExporter from "../components/ExcelExporter.vue";
  
  export default {
    data() {
      return {
        searchText: "",
        showModal: false,
        filter: { DepartmentIds : this.hasAuth("Admin") ? [] : this.$root?.$data?.login?.User?.DepartmentIds ?? [] },
        columns: [
          {
            Key: "Name",
            Title: this.translate('externalSignerImport.externalSignerName'),
          },
          {
            Key: "Surname",
            Title: this.translate('externalSignerImport.externalSignerSurname'),
            SortField: "Surname",
          },
          {
            Key: "Email",
            Title: this.translate('externalSignerImport.email'),
          },
          {
            Key: "Phone",
            Title: this.translate('externalSignerImport.phone'),
          },
          {
            Key: "IdentityNumber",
            Title: this.translate('externalSignerImport.tckn'),
            ExportOnly: true,
          }
        ],
      };
    },
    components: {
      list,
      listContainer,
      ExternalSignerImport,
      ExcelExporter
    },
    methods: {
      searchExternalSigners(searchText) {
        var parts = [];
        console.log(searchText);
        if (searchText != "")
          parts.push(
            ` Name.ToLower().Contains("${searchText.toLowerCase()}")`
          );
        this.predicate = parts.join(" && ");
        this.$refs.externalSigners.predicate = this.predicate;
        this.$refs.externalSigners.getData();
      },
    },
  };
  </script>
  <style scoped>
  .col-search {
    margin-top: 20px;
    float: right;
    clear: both;
    width: 30%;
  }
  .mbm {
    margin-bottom: 10px !important;
  }
  .input-group-btn {
    padding-left: 10px;
    padding-top: 6px;
    padding-right: 10px;
    background-color: #e5e5e5;
    color: #777777;
    border-color: #e5e5e5;
    border: 1px solid #e5e5e5;
    position: relative;
    font-size: 0;
    white-space: nowrap;
  }
  </style>